export class BaseMutationTypes {
  public static readonly SetIsLoading = 'IS_LOADING';
}
